import authenticatedHttpClientFactory from '@/modules/core/services/authenticatedHttpClientFactory';
import { toDateFromPtBr, toPhone } from '@/modules/core/utils/formats';

export const getPaginatedParceiroData = async(options) => {
  const params = getParams(options);
  params.pagina = options.page;
  params.porPagina = 10;
  const httpClient = authenticatedHttpClientFactory();
  const response = await httpClient.get(`parceiro/grid?${new URLSearchParams(params).toString()}`);
  return response.data;
};

export const getAllParceirosData = async(options) => {
  const params = getParams(options);
  params.pagina = 1;
  params.porPagina = 1000000;
  const httpClient = authenticatedHttpClientFactory();
  const response = await httpClient.get(`parceiro/grid?${new URLSearchParams(params).toString()}`);
  return response.data.dados.map((data) => [
    `"${data.nome}"`,
    `"${toPhone(data.telefone)}"`,
    `"${data.email}"`,
    `"${data.quantidadeCodigos != null ? data.quantidadeCodigos : '0'}"`,
  ]);
};

export const addParceiro = async(parceiro) => {
  try {
    const httpClient = authenticatedHttpClientFactory();
    await httpClient.post('parceiro', parceiro);
    return true;
  } catch (error) {
    if (error.response.status === 400) return error.response.data.validation.body.message;
    throw error;
  }
};

export const getParceiro = async(id) => {
  try {
    const httpClient = authenticatedHttpClientFactory();
    const response = await httpClient.get(`parceiro/${id}`);
    return response.data;
  } catch (error) {
    if (error.response.status === 404) return false;
    throw error;
  }
};

export const updateParceiro = async(id, parceiro) => {
  try {
    const httpClient = authenticatedHttpClientFactory();
    await httpClient.put(`parceiro/${id}`, parceiro);
    return true;
  } catch (error) {
    if (error.response.status === 400) return error.response.data.validation.body.message;
    if (error.response.status === 404) return 'Parceiro não encontrado';
    throw error;
  }
};

const getParams = (options) => ({
  ordem: options.order,
  ordenarPor: options.sort,
  pesquisar: options.search,
  dataCriacaoInicial: toDateFromPtBr(options.creationInitialDate),
  dataCriacaoFinal: toDateFromPtBr(options.creationEndDate),
});

export const deleteParceiro = async(id) => {
  try {
    const httpClient = authenticatedHttpClientFactory();
    await httpClient.delete(`parceiro/${id}`);
    return true;
  } catch (error) {
    if (error.response.status === 404) return false;
    throw error;
  }
};
export const enviarEmailCodigos = async(id) => {
  try {
    const httpClient = authenticatedHttpClientFactory();
    await httpClient.post(`codigoParceiro/email/${id}`);
    return true;
  } catch (error) {
    if (error.response.status === 404) return false;
    throw error;
  }
};

export const criarCodigos = async(id, quantidade) => {
  const postObject = {
    parceiroId: id,
    quantidade: quantidade,
  };
  try {
    const httpClient = authenticatedHttpClientFactory();
    await httpClient.post('codigoParceiro', postObject);
    return true;
  } catch (error) {
    if (error.response.status === 400) return error.response.data.validation.body.message;
    throw error;
  }
};
